module.exports = __webpack_public_path__ + "static/media/logo-white.fa22ba93.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Logo/logo-white.png
// module id = 222
// module chunks = 42